import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Button,
  Badge,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "reactstrap";
import Widget from "../../components/Widget/Widget";
import TasksStepper from "./stepper/TasksStepper";
import ApexCharts from "react-apexcharts";
import AvatarGroup from "../../components/AvatarGroup/AvatarGroup";
import s from "./Profile.module.scss";

import moreIcon from "../../assets/tables/moreIcon.svg";
import heartRed from "../../assets/dashboard/heartRed.svg";
import heartTeal from "../../assets/dashboard/heartTeal.svg";

import Avatar from "../../components/Avatar/Avatar";
import { logApp } from "../../utils/func";
import { PROFILE, API_TIMEOUT } from "../../utils/index.js";
import axios from "axios";

import SimObat from "../../components/Icons/simobat.png";

export default function Profile() {
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [wizardDropdownOpen, setWizardDropdownOpen] = useState(false);
  const [smartUser, setSmartUser] = useState(null);
  const [logStats, setLogStats] = useState(null);
  const [pageUsage, setPageUsage] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    if (!smartUser) {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      setSmartUser(currentUser);
      logApp(currentUser.uid, "Profile");
    }
  }, []);

  useEffect(() => {
    if (smartUser && smartUser.uid) {
      ambilDataProfile();
    }
  }, [smartUser]);

  const ambilDataProfile = () => {
    setLoading(true);
    const uid = smartUser.uid;
    const tahun = currentYear;

    const defaultLogStats = {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      userLogs: Array(12).fill(0),
      averageLogs: Array(12).fill(0),
    };

    // Ambil statistik log per bulan
    const logStatsRequest = axios({
      method: "get",
      url: `${PROFILE}log-stats/${uid}?tahun=${tahun}`,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        console.log("Log stats response:", response.data);
        if (response.status === 200 && response.data.success === 1) {
          setLogStats(response.data.data);
        } else {
          console.warn("Log stats response tidak sukses:", response.data);
          setLogStats(defaultLogStats);
        }
      })
      .catch((error) => {
        console.error("Error mengambil statistik log:", error);
        setLogStats(defaultLogStats);
      });

    // Ambil statistik pemanfaatan page
    const pageUsageRequest = axios({
      method: "get",
      url: `${PROFILE}page-usage/${uid}`,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status === 200 && response.data.success === 1) {
          setPageUsage(response.data.data || []);
        }
      })
      .catch((error) => {
        console.error("Error mengambil statistik page usage:", error);
        setPageUsage([]);
      });

    // Ambil aktivitas terbaru
    const recentActivitiesRequest = axios({
      method: "get",
      url: `${PROFILE}recent-activities/${uid}?limit=3`,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status === 200 && response.data.success === 1) {
          setRecentActivities(response.data.data || []);
        }
      })
      .catch((error) => {
        console.error("Error mengambil aktivitas terbaru:", error);
        setRecentActivities([]);
      });

    // Ambil list friends
    const friendsRequest = axios({
      method: "get",
      url: `${PROFILE}friends/${uid}?limit=8`,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status === 200 && response.data.success === 1) {
          const friendsData = (response.data.data || []).map((friend) => ({
            title: friend.nama || friend.username,
            img: friend.photo,
          }));
          setFriends(friendsData);
        } else {
          setFriends([]);
        }
      })
      .catch((error) => {
        console.error("Error mengambil friends:", error);
        setFriends([]);
      });

    // Set loading ke false setelah semua request selesai
    Promise.all([
      logStatsRequest,
      pageUsageRequest,
      recentActivitiesRequest,
      friendsRequest,
    ])
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const profileMenuOpen = () => {
    setProfileDropdownOpen(!profileDropdownOpen);
  };

  const wizardMenuOpen = () => {
    setWizardDropdownOpen(!wizardDropdownOpen);
  };

  return (
    <div>
      <Row className="mb-4">
        <Col lg="6" sm="12" className="mb-4 mb-lg-0">
          <Widget className={`widget-p-md ${s.profile}`}>
            <div className="d-flex justify-content-end">
              <Dropdown
                nav
                isOpen={profileDropdownOpen}
                toggle={() => profileMenuOpen()}
              >
                <DropdownToggle nav className="p-0">
                  <img src={moreIcon} alt="More..." />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>Edit</DropdownItem>
                  <DropdownItem>Delete</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className={s.profileTitle}>
              <img
                className="mx-0 mx-md-2"
                src={
                  smartUser
                    ? smartUser.avatar
                      ? smartUser.avatar
                      : SimObat
                    : SimObat
                }
                alt="..."
                style={{ borderRadius: "50%" }}
              />
              <div className="d-flex flex-column mb-2 ml-3">
                <p className="headline-1">{smartUser && smartUser.nama}</p>
                <p className="body-1 mt-1 mb-3">
                  {smartUser && smartUser.status}
                </p>
                <hr />
                <div className="d-flex flex-row justify-content-between">
                  <a
                    href="https://www.facebook.com/flatlogic"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="eva eva-facebook" />
                  </a>
                  <a
                    href="https://twitter.com/flatlogic/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="eva eva-twitter" />
                  </a>
                  <a
                    href="https://github.com/flatlogic/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="eva eva-github" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/flatlogic/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="eva eva-linkedin" />
                  </a>
                </div>
              </div>
            </div>
            <div className="body-1 mb-4 base-light-gray">
              {smartUser
                ? `Pengguna ${smartUser.nama} dengan level ${
                    smartUser.status || "User"
                  } pada sistem SIMOBAT`
                : "Pengguna sistem SIMOBAT"}
            </div>
            <div className={s.badges}>
              {pageUsage.slice(0, 5).map((page, index) => (
                <Badge
                  key={index}
                  className={`badge-inverse-${
                    index % 5 === 0
                      ? "primary"
                      : index % 5 === 1
                      ? "secondary-red"
                      : index % 5 === 2
                      ? "secondary-yellow"
                      : index % 5 === 3
                      ? "secondary-cyan"
                      : "success"
                  }`}
                >
                  {page.page} ({page.total_akses})
                </Badge>
              ))}
              {pageUsage.length === 0 && (
                <Badge className="badge-inverse-primary">Tidak ada data</Badge>
              )}
            </div>
          </Widget>
        </Col>

        <Col lg="6" sm="12">
          <Widget className="widget-p-md">
            <div className="headline-3 mb-1">Info</div>
            <div className="mb-4">
              <span className="fake-link">SIMOBAT, </span>
              <span className="fake-link">
                Sistem Informasi Manajemen Obat dan BMHP{" "}
              </span>
            </div>
            <div className={s.news}>
              {loading ? (
                <div className="text-center py-4">Memuat data...</div>
              ) : recentActivities.length > 0 ? (
                recentActivities.map((item, index) => (
                  <div key={index} className="d-flex flex-row mb-4">
                    <Avatar
                      className="zoom-in"
                      imgClassName="avatar"
                      size="md"
                      id={index}
                      img={SimObat}
                    />
                    <div className="d-flex flex-column ml-4">
                      <div className="d-flex flex-row">
                        <p className="headline-3 mr-3">{item.page}</p>
                        <p className="body-4 muted">{item.time}</p>
                      </div>
                      <div className="body-3 base-dark-gray">
                        Akses halaman {item.page} pada sistem SIMOBAT
                        <span className="fake-link"> view all</span>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-4">Tidak ada aktivitas</div>
              )}
            </div>
          </Widget>
        </Col>
      </Row>
      <Row>
        <Col lg={6} sm={12}>
          <Row className={s.widgetRow}>
            <Col lg={8} sm={12} className={`mb-4 mb-lg-0 ${s.widgetOverflow}`}>
              <Widget className="widget-p-md">
                <div className="d-flex justify-content-between mb-3">
                  <div className="headline-3 d-flex align-items-center">
                    Overview
                  </div>
                  <ButtonDropdown
                    isOpen={wizardDropdownOpen}
                    toggle={() => wizardMenuOpen()}
                  >
                    <DropdownToggle caret>&nbsp; Week 1 &nbsp;</DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Week 2</DropdownItem>
                      <DropdownItem>Week 3</DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                </div>
                <div className={s.chronoWidget}>
                  <TasksStepper pageUsage={pageUsage} />
                </div>
              </Widget>
            </Col>
            <Col lg={4} sm={12} className="mb-4 mb-lg-0">
              <Row className={s.cardsWidgetRow}>
                <Col sm={4} lg={12} className="mb-4 mb-sm-0 mb-lg-4">
                  <Widget className="widget-p-sm">
                    <div className="d-flex flex-column align-items-center">
                      <img
                        className="img-fluid mb-1"
                        src={heartRed}
                        alt="..."
                      />
                      <div className="my-2 headline-3">Total Akses</div>
                      <div className="body-2 muted">
                        {logStats
                          ? logStats.userLogs.reduce((a, b) => a + b, 0)
                          : 0}
                      </div>
                    </div>
                  </Widget>
                </Col>
                <Col sm={4} lg={12} className="mb-4 mb-sm-0 mb-lg-4">
                  <Widget className="widget-p-sm">
                    <div className="d-flex flex-column align-items-center">
                      <img
                        className="img-fluid mb-1"
                        src={heartTeal}
                        alt="..."
                      />
                      <div className="my-2 headline-3">Rata-rata</div>
                      <div className="body-2 muted">
                        {logStats
                          ? Math.round(
                              logStats.averageLogs.reduce((a, b) => a + b, 0) /
                                12
                            )
                          : 0}
                      </div>
                    </div>
                  </Widget>
                </Col>
                <Col sm={4} lg={12} className={s.widgetOverflow}>
                  <Widget className="widget-p-sm">
                    <div className="d-flex flex-column align-items-center">
                      <div className={`headline-1 ${s.earning}`}>
                        {pageUsage.length > 0 ? pageUsage[0].total_akses : 0}
                      </div>
                      <div className="body-4 muted">
                        {pageUsage.length > 0
                          ? `Halaman ${pageUsage[0].page}`
                          : "Tidak ada data"}
                      </div>
                      <Button color="primary" className="btn-rounded mt-3">
                        Lihat Detail
                      </Button>
                    </div>
                  </Widget>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col lg={6} sm={12}>
          <Row className={s.widgetRow}>
            <Col xs={12} className="mb-4">
              <Widget className="widget-p-md">
                <div className="headline-3">Statistik Log ({currentYear})</div>
                <div className="text-center">
                  {logStats ? (
                    <ApexCharts
                      series={[
                        {
                          name: "Log Saya",
                          data: logStats.userLogs,
                        },
                        {
                          name: "Rata-rata User",
                          data: logStats.averageLogs,
                        },
                      ]}
                      options={{
                        chart: {
                          toolbar: false,
                          zoom: {
                            enabled: false,
                          },
                        },
                        legend: {
                          show: true,
                          position: "top",
                        },
                        dataLabels: {
                          enabled: false,
                        },
                        stroke: {
                          curve: "smooth",
                        },
                        grid: {
                          show: false,
                          row: {
                            colors: ["transparent"],
                          },
                        },
                        xaxis: {
                          categories: logStats.months,
                          labels: {
                            style: {
                              colors: "#6B859E",
                            },
                          },
                        },
                        yaxis: {
                          tickAmount: 3,
                          labels: {
                            style: {
                              colors: "#6B859E",
                            },
                          },
                        },
                        colors: ["#4d53e0", "#41D5E2"],
                      }}
                      height={250}
                    />
                  ) : (
                    <div className="py-5">Memuat data...</div>
                  )}
                  <Button color="secondary-red" className="btn-rounded mt-3">
                    View Analytics
                  </Button>
                </div>
              </Widget>
            </Col>
            <Col xs={12} className={s.widgetOverflow}>
              <Widget className="widget-p-md">
                <p className="headline-2">My Friends</p>
                <div className="d-flex justify-content-between">
                  <div>
                    {loading ? (
                      <div className="text-center py-4">Memuat data...</div>
                    ) : friends.length > 0 ? (
                      <AvatarGroup
                        data={friends}
                        size="lg"
                        placement="top"
                        className="pt-4"
                      />
                    ) : (
                      <div className="text-center py-4">Tidak ada data</div>
                    )}
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <p className="body-1 muted mb-3">
                      {friends.length} Friends
                    </p>
                    <Button
                      color="secondary"
                      className="btn-rounded body-3"
                      outline
                    >
                      + Add new friend
                    </Button>
                  </div>
                </div>
              </Widget>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
